/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowDownToArc = createReactComponent("arrow-down-to-arc", "IconArrowDownToArc", [
  ["path", { d: "M12 3v12", key: "svg-0" }],
  ["path", { d: "M16 11l-4 4l-4 -4", key: "svg-1" }],
  ["path", { d: "M3 12a9 9 0 0 0 18 0", key: "svg-2" }]
]);

export { IconArrowDownToArc as default };
//# sourceMappingURL=IconArrowDownToArc.js.map
